/**
 * Permissões de plano carregadas no token (`org_permissions_plan`).
 *
 * O emissor carimba as permissões de dono para a conta grátis também — foi
 * assim que "Central de campanhas" deixou de sumir só para o plano Essencial.
 * Ver o comentário em `filterCreatorMenuLinks`.
 */
export const READ_CAMPAIGN_CONTENT_PERMISSION = "org:content:read";
export const MANAGE_CAMPAIGN_CONTENT_PERMISSION = "org:content:manager";

export function readOrgPermissionsFromClaims(
  permissions: readonly string[] | undefined,
): readonly string[] {
  return permissions ?? [];
}

export function hasAllOrgPermissions(
  userPermissions: readonly string[] | undefined,
  requiredPermissions: readonly string[],
): boolean {
  if (requiredPermissions.length === 0) {
    return true;
  }
  const granted = new Set(userPermissions ?? []);
  return requiredPermissions.every((permission) => granted.has(permission));
}

/**
 * O claim já chegou nos dois formatos: lista e string separada por vírgula.
 * Tratar os dois aqui evita que cada leitor descubra o segundo sozinho.
 */
export function readOrgPermissionsFromJwtPayload(
  payload: Record<string, unknown>,
): string[] {
  const raw = payload.org_permissions_plan;
  if (Array.isArray(raw)) {
    return raw.map(String);
  }
  if (typeof raw === "string" && raw.length > 0) {
    return raw.split(",").map((entry) => entry.trim());
  }
  return [];
}
